// extracted by mini-css-extract-plugin
export var container = "_92-0";
export var fallback = "_92-5";
export var fallbackIcon = "_92-6";
export var hidden = "_92-2";
export var image = "_92-3";
export var loaded = "_92-4";
export var placeholder = "_92-1";